import React from "react";
import Form from "./Form";
import {useWorkLookup} from "../../hooks/useWorkLookup";
import {useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import Nav from "../Nav/Nav";
import {useParams} from "react-router-dom";




function WorkLookupForm(props){
    let dataFresh = useSelector(getDataFresh);
    const {workLookup} = useParams();
    let work_lookup_loaded = useWorkLookup(workLookup, dataFresh);
    return(
        <div>
            <Nav/>
        <Form
            endpoint={props.endpoint}
            loaded={work_lookup_loaded}
        />
        </div>
    )

}
export default WorkLookupForm;